import Axiosfetch from '../Axiosfetch';
import API from '../APIConstant';
import baseURL from '../Config';

export const FetchUsersByID = (data, UserSuccess, Failure) => {
    Axiosfetch(baseURL + API.ActiveUserByID, "POST", data, UserSuccess, Failure);
};

export const FetchUsers = (data, UserSuccess, Failure) => {
    Axiosfetch(baseURL + API.GetActiveUsers, "GET", data, UserSuccess, Failure);
};

export const FetchActivatedUsers = (data, UserSuccess, Failure) => {
    Axiosfetch(baseURL + API.GetActivatedUsers, "GET", data, UserSuccess, Failure);
};

export const DeleteUser = (data, UserDeleteSuccess, Failure) => {
    Axiosfetch(baseURL + API.DeleteUser, "POST", data, UserDeleteSuccess, Failure);
};

export const ResetPassword = (data, UserDeleteSuccess, Failure) => {
    Axiosfetch(baseURL + API.ResetPassword, "POST", data, UserDeleteSuccess, Failure);
};

export const UserStatus = (data, UserDeleteSuccess, Failure) => {
    Axiosfetch(baseURL + API.UserStatus, "POST", data, UserDeleteSuccess, Failure);
};

export const GetUserPhoto = (data, UserImageSuccess, Failure) => {
    Axiosfetch(baseURL + API.GetUserPhoto, "POST", data, UserImageSuccess, Failure);
};

export const CreateUser = (data, UserDetailsSuccess, Failure) => {
    Axiosfetch(baseURL + API.CreateUser, "POST", data, UserDetailsSuccess, Failure);
};

export const EditUser = (data, UserDetailsSuccess, Failure) => {
    Axiosfetch(baseURL + API.EditUser, "POST", data, UserDetailsSuccess, Failure);
};

export const UploadUserPhoto = (data, UserImageSuccess, Failure) => {
    Axiosfetch(baseURL + API.UploadUserPhoto, "POST", data, UserImageSuccess, Failure);
};